import '@/styles/fonts.css';
import '@/styles/global.css';
import '@/styles/maplibre.css';
import { GatsbyBrowser } from 'gatsby';
import React, { Fragment } from 'react';
import { BookDemoProvider } from './src/contexts/BookDemoContext';

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({
  element,
  props,
}) => {
  const Layout = element.type.Layout ?? Fragment;
  return <Layout {...props}>{element}</Layout>;
};

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({
  element,
}) => <BookDemoProvider>{element}</BookDemoProvider>;
